import React from "react";
import { Drawer } from "antd";
import styled from "styled-components";
import { MODAL_LAYER_Z_INDEX } from "const/modalLayers";

const DEFAULT_MIN_HEIGHT = "30vh";
const DRAWER_HEADER_OFFSET = "55px";

const bodyMinHeight = (props) => `calc(${props.$minHeight} - ${DRAWER_HEADER_OFFSET})`;
const bodyMaxHeight = (props) =>
  props.$maxHeight ? `calc(${props.$maxHeight} - ${DRAWER_HEADER_OFFSET})` : `calc(100vh - ${DRAWER_HEADER_OFFSET})`;

const BottomSheet = React.forwardRef(function BottomSheet(
  { zIndex = MODAL_LAYER_Z_INDEX.BOTTOM_SHEET, height, minHeight = DEFAULT_MIN_HEIGHT, ...props },
  ref,
) {
  return (
    <BottomSheetStyled
      $minHeight={minHeight}
      $maxHeight={height}
      placement="bottom"
      ref={ref}
      zIndex={zIndex}
      {...props}
    />
  );
});

export default BottomSheet;

const BottomSheetStyled = styled(Drawer)`
  --border-radius: 24px;

  .ant-drawer-content-wrapper {
    height: auto !important;
    min-height: ${(props) => props.$minHeight};
    max-height: ${(props) => props.$maxHeight || "100vh"};
    overflow: hidden;
  }
  .ant-drawer-content {
    min-height: ${(props) => props.$minHeight};
    max-height: ${(props) => props.$maxHeight || "100vh"};
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .ant-drawer-header {
    flex-shrink: 0;
  }
  .ant-drawer-body {
    flex: 1 1 auto;
    min-height: ${bodyMinHeight};
    max-height: ${bodyMaxHeight};
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
  }
`;
